<template>
  <div>
    <!-- 实时 -->
    <div class="real-time-box">
      <div class="flex-content w-1400">
        <div class="real-time big-time">
          <div class="title head" @click="goInner">实时询单</div>
          <div class="desc">你离订单之间只差一个报价！</div>
          <div class="content">
            <div class="title-box">
              <el-row :gutter="24">
                <el-col :span="4"> 产品名称</el-col>
                <el-col :span="3"> cas</el-col>
                <el-col :span="4"> 收货地</el-col>
                <el-col :span="3"> 已报价</el-col>
                <el-col :span="5"> 订单截止时间</el-col>
                <el-col :span="4"> 操作</el-col>
              </el-row>
            </div>
            <vue-seamless-scroll :data="tableData" class="warp" :class-option="classOption">
              <el-row :gutter="24" v-for="tab in tableData" :key="tab.id" class="table-box">
                <el-col :span="4" class="ellipsis">
                  <el-tooltip class="fill-box" effect="dark" :content="tab.product_name" placement="top">
                    <span>{{ tab.product_name || "--" }}</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="3" class="ellipsis">
                  <el-tooltip class="fill-box" effect="dark" :content="tab.cas_no" placement="top">
                    <span>{{ tab.cas_no || "--" }}</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="4" class="text-center-area ellipsis">
                  <el-tooltip class="item" effect="dark" :content="tab.province + tab.city + tab.area"
                              placement="top">
                    <span>{{ tab.province + tab.city + tab.area }}</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="3" class="ellipsis">
                  <span class="orange-color"> {{ tab.quote_count }}</span>
                </el-col>
                <el-col :span="5" class="ellipsis">
                  <span class="gray-color"> {{ tab.end_at }}</span>
                </el-col>
                <el-col :span="4" class="ellipsis">
                  <div class="button-style hit-cursor" @click="showDong(tab)">
                    我要报价
                  </div>
                </el-col>
              </el-row>
            </vue-seamless-scroll>
          </div>
        </div>

        <div class="real-time small-time">
          <div class="title">实时成交</div>
          <div class="desc">你的报价，正在转化为实实在在的订单！</div>
          <div class="content">
            <div class="title-box">
              <el-row :gutter="24">
                <el-col :span="9"> 产品名称</el-col>
                <el-col :span="6"> cas</el-col>
                <el-col :span="4"> 数量</el-col>
                <el-col :span="5"> 状态</el-col>
              </el-row>
            </div>
               <vue-seamless-scroll :data="priceList" class="warp" :class-option="classOption">
                   <el-row v-for="item in priceList" :key="item.id" :gutter="24" class="table-box">
                  <el-col :span="9" class="ellipsis">
                    <el-tooltip class="fill-box" effect="dark" :content="item.product_name" placement="top">
                      <span>{{ item.product_name || "--" }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="6" class="ellipsis">
                    <el-tooltip class="fill-box" effect="dark" :content="item.cas_no" placement="top">
                      <span> {{ item.cas_no || "--" }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4"> {{ item.number }}{{ item.unit }}</el-col>
                  <el-col :span="5">
                    <span class="orange-color" v-if="item.status == 1">订单生成</span>
                    <span class="orange-color" v-if="item.status == 2">支付成功</span>
                    <span class="orange-color" v-if="item.status == 3">已发货</span>
                    <span class="orange-color" v-if="item.status == 4">已收货</span>
                    <span class="orange-color" v-if="item.status == 5">已完成</span>
                  </el-col>
                </el-row>

                    </vue-seamless-scroll>
<!--            <el-carousel height="650px" direction="vertical" v-if="priceList.length > 0">-->
<!--              <el-carousel-item v-for="(deal, index) in priceList" :key="index">-->

<!--                 </el-carousel-item>-->
<!--            </el-carousel>-->
          </div>
        </div>
      </div>

    </div>
    <!-- 我要报价弹窗 -->
    <QuotationAdd :dialogVisible="dialogVisible" @refresh="getOnlinePurchase" @changeDialog="changeDialog"
                  :row="selectInner"></QuotationAdd>
  </div>
</template>
<script>

import {online_deal, online_purchase} from "@/api/modules/home";
import QuotationAdd from "@/components/addInfo/quotationAdd.vue";
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: "scollList",
  components: {QuotationAdd, vueSeamlessScroll},
  data() {
    return {
      classOption:{
        waitTime: 1,
      },
      tableData: [],
      priceList: [],
      dialogVisible: false,
      // 我要报价选择的数据
      selectInner: {},
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },

  mounted() {
    this.getOnlineDeal();
    this.getOnlinePurchase();

  },
  methods: {
    goInner() {
      this.$router.push({
        path: '/purchase',
      })
    },
    // 显示我要报价的弹窗
    changeDialog(e) {
      this.dialogVisible = e
    },
    // 展示我要报价
    showDong(e) {
      if (this.mixCheckLogin() && this.mixCheckUserAudit()) {
        if (this.userInfo.id == e.people_id) {
          this.$message({
            message: '您不能报价自己发布的求购',
            type: 'warning'
          })
          return
        }
        this.selectInner = e
        this.dialogVisible = true
      }
    },

    // 实时求购
    async getOnlinePurchase() {
      let res = await online_purchase({page: 1, limit: 24});
      if (res.data.code === 10000) {
        // this.tableData = this.$utils.handleArray(res.data.data.data, 6);
        this.tableData = res.data.data.data
      }
    },
    // 实时成交
    async getOnlineDeal() {
      let res = await online_deal({
        page: 1,
        limit: 24,
      });
      this.priceList = res.data.data.data
    },
  }
}
</script>

<style scoped lang="scss">
.warp {
  height: 300px;
  margin: 0 auto;
  overflow: hidden;
}
.head{
  cursor: pointer;
}

.real-time-box {
  position: relative;
  // height: 704px;
  background: #ffffff;
  box-sizing: border-box;

  .flex-content {
    display: flex;
    justify-content: space-between;

    .big-time {
      width: 60%;
      box-sizing: border-box;
    }

    .small-time {
      // width: 610px;
      flex: 1;
      margin-left: 24px;
      box-sizing: border-box;
    }

    .real-time {
      height: 100%;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      padding: 40px 0;

      .title {
        font-weight: 800;
        font-size: var(--font-size-default-big);
        color: #00112b;
        line-height: 53px;
        text-align: center;
        margin-block: 10px;
      }

      .desc {
        font-weight: 500;
        font-size: var(--font-size-default-18);
        color: #5f616c;
        line-height: 28px;
        text-align: center;
        margin-bottom: 40px;
      }

      .content {
        box-sizing: border-box;
        height: 422px;
        background: linear-gradient(180deg, #e0e8f5 0%, #fefefe 100%);
        box-shadow: 0px 10px 36px 1px rgba(22, 24, 26, 0.03);
        border: 1px solid #ffffff;
        padding: 40px 40px;
        overflow: hidden;
        font-size: 18px;

        .table-box {
          text-align: center;
          margin-bottom: 20px;


          .text-center-area {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .fill-box {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .button-style {
            width: 100px;
            height: 30px;
            font-size: 16px;
            text-align: center;
            line-height: 30px;
            color: #ffffff;
            background: linear-gradient(306deg, #578fff 0%, #236cff 100%);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #2979f1;
          }

          .orange-color {
            font-weight: bold;
            color: #ff7902;
            text-align: center;
          }

          .gray-color {
            font-weight: 400;
            color: #3d3d3d;
          }
        }

        .title-box {
          font-weight: bold;
          color: #00112b;
          line-height: 33px;
          text-align: center;
          padding-bottom: 25px;
        }
      }
    }
  }
}

</style>
